import { useMutation } from '@tanstack/react-query';

import { appHttp } from '@/lib/http.client';

export const useSignOutMutation = () => {
  return useMutation({
    mutationFn: async () => {
      if (typeof window === 'undefined') {
        return; // Should not be called on server
      }

      const redirectLink = await logout();
      if (redirectLink) {
        window.location.href = redirectLink;
      }
    },
  });
};

// Logout function - client side
export const logout = async () => {
  // Call the server logout endpoint
  const response = await appHttp.post('/api/auth/logout');

  const cognitoDomain = import.meta.env.VITE_ALPHA_1EDTECH_API_IDP;
  const redirectLink = new URL(`${cognitoDomain}/logout`);
  redirectLink.searchParams.set(
    'client_id',
    import.meta.env.VITE_ALPHA_COGNITO_SIGNIN_CLIENT_ID
  );
  redirectLink.searchParams.set(
    'logout_uri',
    `${window.location.origin}/login`
  );

  if (response.status === 200) {
    // Reload the page to clear client state
    return redirectLink.toString();
  }

  console.error('Failed to logout', response);

  return null;
};
